import { Text, VStack } from '@chakra-ui/react'

interface Props {
  title?: React.ReactNode
  subtitle?: React.ReactNode
  children: React.ReactNode
}

function Section({ title, subtitle, children }: Props): React.ReactElement {
  return (
    <VStack
      spacing={{
        base: 4,
        md: 8,
      }}
      as="section"
      layerStyle="container"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'gray.300',
        alignItems: 'stretch',
      }}
    >
      {(title || subtitle) && (
        <VStack spacing="1" layerStyle="landingSectionHeading">
          {title && (
            <Text
              as="h1"
              sx={{
                fontSize: {
                  base: '3xl',
                  sm: '4xl',
                },
                fontWeight: 'medium',
                textAlign: 'center',
              }}
            >
              {title}
            </Text>
          )}
          {subtitle && (
            <Text as="h2" textStyle="landingSectionSubtitle">
              {subtitle}
            </Text>
          )}
        </VStack>
      )}
      {children}
    </VStack>
  )
}

export default Section
